import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Time in milliseconds after data is considered stale
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Time in milliseconds after inactive queries will be removed from cache (renamed in v4)
      gcTime: 10 * 60 * 1000, // 10 minutes
      // Refetch when window regains focus
      refetchOnWindowFocus: false,
      // Retry failed requests
      retry: 1,
      // Refetch when component mounts if data is stale
      refetchOnMount: "always",
    },
    mutations: {
      // Retry failed mutations
      retry: 1,
    },
  },
});

interface ReactQueryProviderProps {
  children: React.ReactNode;
}

export const ReactQueryProvider: React.FC<ReactQueryProviderProps> = ({
  children,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export { queryClient };
